"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GolfCourseToJSON = exports.GolfCourseFromJSONTyped = exports.GolfCourseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function GolfCourseFromJSON(json) {
    return GolfCourseFromJSONTyped(json, false);
}
exports.GolfCourseFromJSON = GolfCourseFromJSON;
function GolfCourseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': json['_id'],
        'golfCourseType': _1.GolfCourseTypeFromJSON(json['golfCourseType']),
        'searchable': json['searchable'],
        'demo': json['demo'],
        'courseRating': !runtime_1.exists(json, 'courseRating') ? undefined : json['courseRating'],
        'maleCourseRating': !runtime_1.exists(json, 'maleCourseRating') ? undefined : json['maleCourseRating'],
        'femaleCourseRating': !runtime_1.exists(json, 'femaleCourseRating') ? undefined : json['femaleCourseRating'],
        'slopeRating': !runtime_1.exists(json, 'slopeRating') ? undefined : json['slopeRating'],
        'maleSlopeRating': !runtime_1.exists(json, 'maleSlopeRating') ? undefined : json['maleSlopeRating'],
        'femaleSlopeRating': !runtime_1.exists(json, 'femaleSlopeRating') ? undefined : json['femaleSlopeRating'],
        'source': _1.GolfCourseSourceFromJSON(json['source']),
        'holes': !runtime_1.exists(json, 'holes') ? undefined : (runtime_1.mapValues(json['holes'], _1.HoleInfoFromJSON)),
        'address': !runtime_1.exists(json, 'address') ? undefined : json['address'],
        'country': !runtime_1.exists(json, 'country') ? undefined : json['country'],
        'province': !runtime_1.exists(json, 'province') ? undefined : json['province'],
        'golfClub': json['golfClub'],
        'createdBy': !runtime_1.exists(json, 'createdBy') ? undefined : _1.UserFromJSON(json['createdBy']),
    };
}
exports.GolfCourseFromJSONTyped = GolfCourseFromJSONTyped;
function GolfCourseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'golfCourseType': _1.GolfCourseTypeToJSON(value.golfCourseType),
        'searchable': value.searchable,
        'demo': value.demo,
        'courseRating': value.courseRating,
        'maleCourseRating': value.maleCourseRating,
        'femaleCourseRating': value.femaleCourseRating,
        'slopeRating': value.slopeRating,
        'maleSlopeRating': value.maleSlopeRating,
        'femaleSlopeRating': value.femaleSlopeRating,
        'source': _1.GolfCourseSourceToJSON(value.source),
        'holes': value.holes === undefined ? undefined : (runtime_1.mapValues(value.holes, _1.HoleInfoToJSON)),
        'address': value.address,
        'country': value.country,
        'province': value.province,
        'golfClub': value.golfClub,
        'createdBy': _1.UserToJSON(value.createdBy),
    };
}
exports.GolfCourseToJSON = GolfCourseToJSON;
